import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=3a6fe7a2"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a6fe7a2')) {
      api.createRecord('3a6fe7a2', component.options)
    } else {
      api.reload('3a6fe7a2', component.options)
    }
    module.hot.accept("./Content.vue?vue&type=template&id=3a6fe7a2", function () {
      api.rerender('3a6fe7a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/ServerSideDatatable/Content.vue"
export default component.exports